import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Два коротких поля одной строкой: пол и возраст в анкете. Вместо вкуишного
 * FormLayoutGroup — тот собирал ряд из fieldset, распорки и отрицательного
 * поля; поля и шаг здесь те же: 16 по бокам и между полями.
 */
export function FieldPair({ children }: { children: ReactNode }) {
  return <div className={styles.fieldPair}>{children}</div>;
}
